import { Link } from "react-router-dom";
import { ArrowRight, CalendarCheck } from "lucide-react";
import { Reveal } from "./motion";

export const CTAPanel = ({
  title = "Ready to go live?",
  sub = "Tell us about your business and we'll map out the fastest, most affordable way to get you online — free, no strings.",
}) => (
  <section className="px-5 sm:px-8 py-24 sm:py-32" data-testid="cta-panel">
    <Reveal className="max-w-6xl mx-auto">
      <div className="relative overflow-hidden rounded-[2.5rem] bg-ink grain px-8 py-16 sm:px-16 sm:py-24">
        <div className="absolute -top-32 -right-32 w-96 h-96 rounded-full bg-indigo/30 blur-[120px]" />
        <div className="absolute -bottom-32 -left-32 w-96 h-96 rounded-full bg-mint/20 blur-[120px]" />
        <div className="relative z-10 max-w-2xl">
          <h2 className="font-display font-bold text-white text-4xl sm:text-5xl leading-[1.08]">{title}</h2>
          <p className="mt-5 text-white/60 text-base sm:text-lg leading-relaxed">{sub}</p>
          <div className="mt-10 flex flex-wrap gap-4">
            <Link
              to="/contact"
              data-testid="cta-panel-primary-button"
              className="inline-flex items-center gap-2 bg-gradient-to-r from-indigo to-mint text-white font-semibold px-7 py-3.5 rounded-full hover:opacity-90 hover:scale-[1.02] transition-[opacity,transform] duration-300"
            >
              Get Your Free Digital Health Check <ArrowRight className="w-4 h-4" />
            </Link>
            <Link
              to="/contact"
              data-testid="cta-panel-secondary-button"
              className="inline-flex items-center gap-2 border border-white/20 text-white font-semibold px-7 py-3.5 rounded-full hover:bg-white/10 transition-colors duration-300"
            >
              <CalendarCheck className="w-4 h-4" /> Book a Free Consultation
            </Link>
          </div>
        </div>
      </div>
    </Reveal>
  </section>
);
